<template>
  <div>
    <v-card
      :style="`
      border: ${border_px}px solid ${border_color};
      `"
      flat
      tile
      :color="bgcolor"
    >
      <v-card-text>
        <v-radio-group v-model="ans">
          <v-row>
            <v-col
              v-for="(button, i) in Button"
              :key="i"
              :cols="radio_row ? 3 : 12"
              class="py-1 d-flex align-start"
            >
              <v-radio :color="color" :value="button"></v-radio>
              <span
                :style="`color:${color_text};font-size: 18px;word-break: break-word;`"
                >{{ button }}</span
              >
            </v-col>
          </v-row>
        </v-radio-group>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "radio_row",
    "bgcolor",
    "color",
    "color_text",
    "border_px",
    "border_color",
  ],
  data() {
    return {
      ans: null,
    };
  },
  watch: {
    ans() {
      this.$emit("Answer", this.ans);
    },
  },
  computed: {
    Button() {
      if (this.data) {
        let conditions;
        conditions = this.data.conditionsAnswer;
        let match = conditions.match;
        let allname = [];
        let allbutton = [];
        match.map((cond) => {
          let fixname = cond.fixtext[0];
          let dup = allname.find((text) => text === fixname);
          if (!dup) {
            if (cond.score.operation !== "!!") {
              allbutton.push(fixname);
            }
          }
          allname.push(fixname);
        });
        return allbutton;
      }
      return [];
    },
  },
  methods: {
    setAns(ans) {
      this.ans = ans;
    },
  },
};
</script>

<style lang="scss" scoped></style>
